function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */
var moneyFormat = "${{amount}}";
/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;
  function formatWithDelimiters(number) {
    var precision =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ",";
    var decimal =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split(".");
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1".concat(thousands)
    );
    var centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.opener = this.querySelector(".global--mobile-menu__wrapper");
    this.icon = this.querySelector(".global--mobile-menu__icon");
    this.nav = this.querySelector(".global--mobile-menu__content");
    this.bindEvents();
  }
  bindEvents() {
    this.opener.addEventListener("click", this.toggleMenu.bind(this));
  }
  toggleMenu() {
    if (
      this.opener.classList.contains("global--mobile-menu__wrapper--active")
    ) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  openMenu() {
    document.body.style.overflow = "hidden";
    this.nav.classList.add("global--mobile-menu__content--active");
      if(this.nav.classList.contains('animate__fadeOutLeft')){
        this.nav.classList.remove('animate__fadeOutLeft')
      }
      this.nav.classList.add('animate__fadeInLeft')
    this.icon.classList.add("global--mobile-menu__icon--active");
    this.opener.classList.add("global--mobile-menu__wrapper--active");
  }
  closeMenu() {
    document.body.style.overflow = "visible";
      if(this.nav.classList.contains('animate__fadeInLeft')){
        this.nav.classList.remove('animate__fadeInLeft')
      }
      this.nav.classList.add('animate__fadeOutLeft')
      setTimeout(() => {
    this.nav.classList.remove("global--mobile-menu__content--active");
      },600)
    this.icon.classList.remove("global--mobile-menu__icon--active");
    this.opener.classList.remove("global--mobile-menu__wrapper--active");
  }
}
customElements.define("mobile-menu", MobileMenu);
  class MegaMenu extends HTMLElement {
    constructor() {
      super();
      this.hover = false;
      this.opener = document.querySelector("[data-mega-menu-trigger]");
      this.content = this.querySelector(".global--mega-menu__content");
      this.bindEvents();
    }
    bindEvents() {
      this.opener.addEventListener("mouseenter", this.openMenu.bind(this));
      this.opener.addEventListener("mouseleave", this.closeMenu.bind(this));
      this.content.addEventListener("mouseenter", this.openMenu.bind(this));
      this.content.addEventListener("mouseleave", this.closeMenu.bind(this));
    }
    toggleMenu() {
      if (this.opener.classList.contains("global--mega-menu__wrapper--active")) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    }
    openMenu() {
      this.content.classList.add("global--mega-menu__content--active");
      this.opener.classList.add("component--header--menu__item--active");
    }
    closeMenu() {
      this.content.classList.remove("global--mega-menu__content--active");
      this.opener.classList.remove("component--header--menu__item--active");
    }
  }
  customElements.define("mega-menu", MegaMenu);
/* =========================================================
   Cart Drawer + Incentives + Gift Auto Add/Remove (FULL)
   - Fixes: 0% progress bar (config must include t1/e1/l1)
   - Uses ONE cart update pipeline (__applyCartUpdate)
   - ONE fetch hook (no duplicate wrapping)
   - Gifts add/remove based on line-item property _incentive_gift
   - Removes gifts by item.key (reliable)
   - Refreshes cart drawer section when open so UI updates instantly
   ========================================================= */

/* ---------- Helpers ---------- */
/* =========================================================
   Cart Drawer + Incentives + Gift Auto Add/Remove (FULL)
   FIX INCLUDED:
   - Plus button quantity going to 0: removed aggressive clearCart() call
     from updateQuantity(). We ALWAYS re-render drawer section instead.
   ========================================================= */

/* ---------- Helpers ---------- */
function clampPercent(n) {
  if (!isFinite(n)) return 0;
  return Math.max(0, Math.min(100, n));
}

function formatMoney(cents) {
  const value = Math.max(0, Number(cents || 0));
  if (typeof window.Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
    return Shopify.formatMoney(value);
  }
  return `$${(value / 100).toFixed(2)}`;
}

/* Refresh drawer markup when gift adds/removes (only if drawer is open) */
async function refreshCartDrawerIfOpen() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  const drawerEl = document.querySelector(".global--cart-drawer__drawer");
  const isOpen = drawerEl && drawerEl.classList.contains("global--cart-drawer__drawer--active");
  if (!isOpen) return;

  const state = await fetch(`/?section_id=hd--global--cart-drawer`).then((r) => r.text());
  cartDrawer.renderContents(state);
}

/* =========================================================
   CART DRAWER CLASSES
   ========================================================= */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.defaults = {
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerTrigger: "[data-cart-drawer-trigger]",
      cartOverlay: "[data-cart-drawer-overlay]",
    };

    this.bindEvents();
    this.remountUpsell();
    this.mountTags();

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value, 10),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 100);

    const content = document.querySelector(".global--cart-drawer__content");
    if (content) content.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  bindEvents() {
    const trigger = document.querySelector(this.defaults.cartDrawerTrigger);
    if (trigger) trigger.addEventListener("click", this.openCart.bind(this));

    document.querySelectorAll(this.defaults.cartDrawerClose).forEach((item) =>
      item.addEventListener("click", this.closeCart.bind(this))
    );

    const overlay = document.querySelector(this.defaults.cartOverlay);
    if (overlay) overlay.addEventListener("click", this.closeCart.bind(this));

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value, 10),
      0
    );

    const countEl = document.querySelector(".component--header--cart-icon__count");
    if (countEl) countEl.innerHTML = this.currentItemCount;
  }

  onChange(event) {
    // ✅ sanitize quantity to avoid empty/NaN issues
    const qty = parseInt(event.target.value, 10);
    this.updateQuantity(event.target.dataset.index, Number.isNaN(qty) ? 0 : qty);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section);
      if (!el) return;
      el.innerHTML = this.getSectionInnerHTML(parsedState, section);
    });

    this.bindEvents();
    this.openCart();
    this.remountUpsell();
    this.mountTags();
  }

  remountUpsell() {
    if (document.querySelectorAll(".component--cart-drawer--upsell-slider--card").length == 0) {
      const upsell = document.querySelector(".component--cart-drawer--upsell-slider");
      if (upsell) upsell.style.display = "none";
    } else {
      const upsell = document.querySelector(".component--cart-drawer--upsell-slider");
      if (upsell) upsell.style.display = "block";

      new Splide(".component--cart-drawer--upsell-slider__splide", {
        type: "slider",
        perPage: 1,
        pagination: false,
        arrows: false,
        width: "100%",
        gap: "1rem",
      }).mount();
    }
  }

  mountTags() {
    if (document.querySelectorAll(".component--cart-drawer--tags").length > 0) {
      new Splide(".component--cart-drawer--tags__splide", {
        type: "loop",
        perPage: 9,
        drag: false,
        pagination: false,
        arrows: false,
        autoWidth: true,
        gap: "24px",
        autoScroll: {
          speed: 0.2,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount(window.splide.Extensions);
    }
  }

  getSectionsToRender() {
    return [`component--cart-drawer--body`, `component--cart-drawer--footer`];
  }

  getSectionInnerHTML(html, selector) {
    const h = new DOMParser().parseFromString(html, "text/html");
    const node = h.getElementById(selector);
    return node ? node.innerHTML : "";
  }

  publishCartUpdated(cart) {
    try {
      if (window.__applyCartUpdate) {
        window.__applyCartUpdate(cart);
      } else {
        if (typeof window.updateIncentivesUI === "function") window.updateIncentivesUI(cart);
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
      }
    } catch (e) {
      console.log(e);
    }
  }

  updateQuantity(line, quantity) {
    const body = JSON.stringify({ line, quantity });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((res) => {
        const cart = JSON.parse(res);

        this.publishCartUpdated(cart);

        // ✅ FIX: Always re-render drawer; DO NOT call clearCart() here.
        fetch(`/?section_id=hd--global--cart-drawer`)
          .then((response) => response.text())
          .then((state) => {
            this.renderContents(state);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  openCart() {
    document.body.style.overflow = "hidden";
    const drawer = document.querySelector(".global--cart-drawer__drawer");
    if (drawer) {
      drawer.style.display = "flex";
      drawer.classList.add("global--cart-drawer__drawer--active");
    }
    const overlay = document.querySelector(".global--cart-drawer__overlay");
    if (overlay) overlay.classList.add("global--cart-drawer__overlay--active");
  }

  closeCart() {
    document.body.style.overflow = "visible";
    const drawer = document.querySelector(".global--cart-drawer__drawer");
    if (drawer) drawer.classList.remove("global--cart-drawer__drawer--active");
    const overlay = document.querySelector(".global--cart-drawer__overlay");
    if (overlay) overlay.classList.remove("global--cart-drawer__overlay--active");

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("cart")) {
      urlParams.delete("cart");
      let newUrl = window.location.pathname;
      if (urlParams.toString()) newUrl += "?" + urlParams.toString();
      window.history.replaceState({}, "", newUrl);
    }
  }

  clearCart() {
    fetch(`${routes.cart_clear_url}`, { ...fetchConfig("javascript") })
      .then(() => fetch("/cart.js").then((r) => r.json()))
      .then((cart) => {
        this.publishCartUpdated(cart);

        fetch(`/?section_id=hd--global--cart-drawer`)
          .then((response) => response.text())
          .then((state) => {
            this.renderContents(state);
          });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-drawer-remove-button", CartDrawerRemoveButton);

class CartDrawerQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    // ✅ Fix: use currentTarget so nested SVG clicks don't break name detection
    const btn = event.currentTarget;
    const previousValue = this.input.value;

    btn.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("cart-drawer-quantity-input", CartDrawerQuantityInput);

class CartDrawerProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then(() => fetch("/cart.js").then((r) => r.json()))
      .then((cart) => {
        if (this.cart && typeof this.cart.publishCartUpdated === "function") {
          this.cart.publishCartUpdated(cart);
        } else if (window.__applyCartUpdate) {
          window.__applyCartUpdate(cart);
        }
      })
      .then(() => {
        return fetch(`/?section_id=hd--global--cart-drawer`)
          .then((response) => response.text())
          .then((state) => {
            if (this.cart) this.cart.renderContents(state);
          });
      })
      .catch((e) => console.error(e))
      .finally(() => submitButton.removeAttribute("disabled"));
  }
}
customElements.define("cart-drawer-product-form", CartDrawerProductForm);

/* =========================================================
   Incentives UI updater
   ========================================================= */
window.updateIncentivesUI = function updateIncentivesUI(cart) {
  const drawer = document.querySelector(".global--cart-drawer__drawer");
  const isEmpty =
    !cart ||
    (typeof cart.item_count === "number" ? cart.item_count === 0 : false) ||
    (Array.isArray(cart.items) ? cart.items.length === 0 : false);

  if (drawer) drawer.classList.toggle("cart-drawer--empty", isEmpty);

  const total = cart && typeof cart.total_price === "number" ? cart.total_price : 0;

  document.querySelectorAll("[data-incentives]").forEach((root) => {
    const cfgEl = root.querySelector("[data-incentives-config]");
    if (!cfgEl) return;

    let cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent || "{}");
    } catch {
      return;
    }

    const t1 = Number(cfg.t1 || 0);
    const t2 = Number(cfg.t2 || 0);
    const t3 = Number(cfg.t3 || 0);

    const l1 = cfg.l1 || "Offer 1";
    const l2 = cfg.l2 || "Offer 2";
    const l3 = cfg.l3 || "Offer 3";

    const has1 = cfg.e1 === true && t1 > 0;
    const has2 = cfg.e2 === true && t2 > t1;
    const has3 = cfg.e3 === true && t3 > t2;

    const p1 = has1 ? clampPercent((total / t1) * 100) : 0;

    let p2 = 0;
    if (has2) {
      if (total <= t1) p2 = 0;
      else if (total >= t2) p2 = 100;
      else p2 = clampPercent(((total - t1) / (t2 - t1)) * 100);
    }

    let p3 = 0;
    if (has3) {
      if (total <= t2) p3 = 0;
      else if (total >= t3) p3 = 100;
      else p3 = clampPercent(((total - t2) / (t3 - t2)) * 100);
    }

    let headline = "";
    if (has1 && total < t1) headline = `Add ${formatMoney(t1 - total)} more to get ${l1}`;
    else if (has2 && total < t2) headline = `Add ${formatMoney(t2 - total)} more to get ${l2}`;
    else if (has3 && total < t3) headline = `Add ${formatMoney(t3 - total)} more to get ${l3}`;
    else headline = "You’ve unlocked all rewards!";

    const textEl = root.querySelector("[data-incentives-text]");
    if (textEl) textEl.textContent = headline;

    const fill1 = root.querySelector('[data-incentives-fill="1"]');
    const fill2 = root.querySelector('[data-incentives-fill="2"]');
    const fill3 = root.querySelector('[data-incentives-fill="3"]');

    if (fill1) fill1.style.width = `${p1}%`;
    if (fill2) fill2.style.width = `${p2}%`;
    if (fill3) fill3.style.width = `${p3}%`;
  });
};

/* =========================================================
   Cart Update Bus + Single Fetch Hook
   ========================================================= */
(function cartUpdateBus() {
  if (window.__cartUpdateBusInit) return;
  window.__cartUpdateBusInit = true;

  const originalFetch = window.fetch.bind(window);

  let lastCart = null;
  let scheduled = false;

  async function fetchCartUsingOriginal() {
    return originalFetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json());
  }

  async function applyCartUpdate(cart) {
    lastCart = cart;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          if (typeof window.updateIncentivesUI === "function") window.updateIncentivesUI(lastCart);
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: lastCart } }));
        } catch (e) {
          console.log(e);
        }
      });
    });
  }

  window.__applyCartUpdate = function (cart) {
    if (!cart) return;
    lastCart = cart;
    if (scheduled) return;

    scheduled = true;
    Promise.resolve().then(async () => {
      scheduled = false;
      await applyCartUpdate(lastCart);
    });
  };

  window.fetch = function (...args) {
    return originalFetch(...args).then(async (res) => {
      try {
        const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
        const isCartMutation =
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/clear");

        if (isCartMutation && res && res.ok) {
          const cart = await fetchCartUsingOriginal();
          window.__applyCartUpdate(cart);
        }
      } catch {
        // ignore
      }
      return res;
    });
  };

  document.addEventListener("DOMContentLoaded", async () => {
    try {
      const cart = await fetchCartUsingOriginal();
      window.__applyCartUpdate(cart);
    } catch {}
  });
})();

/* =========================================================
   Gift Auto Add + Remove (property-based, remove by item.key)
   ========================================================= */
(function incentivesGiftAutoAddRemove() {
  if (window.__incentivesGiftAutoAddRemoveInit) return;
  window.__incentivesGiftAutoAddRemoveInit = true;

  const originalFetch = window.fetch.bind(window);
  let running = false;

  function getConfig() {
    const el = document.querySelector("[data-incentives] [data-incentives-config]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch {
      return null;
    }
  }

  async function fetchCartOriginal() {
    return originalFetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json());
  }

  function isGiftLine(item, giftKey) {
    const props = item && item.properties ? item.properties : {};
    return props && props._incentive_gift === giftKey;
  }

  function cartHasGift(cart, giftKey) {
    return (cart.items || []).some((item) => isGiftLine(item, giftKey));
  }

  async function addGiftVariantOriginal(variantId, giftKey) {
    const v = Number(variantId || 0);
    if (!v) return;

    const body = JSON.stringify({
      items: [{ id: v, quantity: 1, properties: { _incentive_gift: giftKey } }]
    });

    await originalFetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body
    });
  }

  async function removeGiftByKey(cart, giftKey) {
    for (const item of (cart.items || [])) {
      if (isGiftLine(item, giftKey)) {
        const body = JSON.stringify({ id: item.key, quantity: 0 });

        await originalFetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body
        });
      }
    }
    return fetchCartOriginal();
  }

  async function run(cartMaybe) {
    if (running) return;
    running = true;

    try {
      const cfg = getConfig();
      if (!cfg) return;

      let cart = cartMaybe || (await fetchCartOriginal());
      const total = Number(cart.total_price || 0);

      const t2 = Number(cfg.t2 || 0);
      const t3 = Number(cfg.t3 || 0);

      const gift2Variant = Number(cfg.gift2_variant_id || 0);
      const gift3Variant = Number(cfg.gift3_variant_id || 0);

      const eligible2 = cfg.e2 === true && t2 > 0 && gift2Variant > 0 && total >= t2;
      const eligible3 = cfg.e3 === true && t3 > 0 && gift3Variant > 0 && total >= t3;

      // Remove when ineligible
      if (!eligible3 && cartHasGift(cart, "gift3")) {
        cart = await removeGiftByKey(cart, "gift3");
        await refreshCartDrawerIfOpen();
        if (window.__applyCartUpdate) window.__applyCartUpdate(cart);
      }

      if (!eligible2 && cartHasGift(cart, "gift2")) {
        cart = await removeGiftByKey(cart, "gift2");
        await refreshCartDrawerIfOpen();
        if (window.__applyCartUpdate) window.__applyCartUpdate(cart);
      }

      // Add when eligible
      if (eligible2 && !cartHasGift(cart, "gift2")) {
        await addGiftVariantOriginal(gift2Variant, "gift2");
        cart = await fetchCartOriginal();
        await refreshCartDrawerIfOpen();
        if (window.__applyCartUpdate) window.__applyCartUpdate(cart);
      }

      if (eligible3 && !cartHasGift(cart, "gift3")) {
        await addGiftVariantOriginal(gift3Variant, "gift3");
        cart = await fetchCartOriginal();
        await refreshCartDrawerIfOpen();
        if (window.__applyCartUpdate) window.__applyCartUpdate(cart);
      }
    } finally {
      running = false;
    }
  }

  document.addEventListener("cart:updated", (e) => run(e.detail && e.detail.cart));
  // waqar--changes
  document.addEventListener("cart:updated", async (e) => {
  try {
    const cart = e.detail && e.detail.cart;
    if (!cart) return;

    const freeGiftId = 45514264903897;

    const triggerIds = [
      48559660957913,
      46856086716633,
      47617803780313,
      47617839300825,
      43731293110489,
      44822222504153,
      44822223290585,
      44822223814873
    ];

    const hasTrigger = (cart.items || []).some(item =>
      triggerIds.includes(Number(item.variant_id))
    );

    if (hasTrigger) return;

    const freeGiftItems = (cart.items || []).filter(item =>
      Number(item.variant_id) === freeGiftId &&
      item.properties &&
      item.properties._free_gift === 'true'
    );

for (const item of freeGiftItems) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: item.key,
      quantity: 0
    })
  });
}

const state = await fetch('/?section_id=hd--global--cart-drawer')
  .then(r => r.text());

const drawer = document.querySelector('cart-drawer');

if (drawer) {
  const drawerBox = document.querySelector('.global--cart-drawer__drawer');
  const wasOpen = drawerBox &&
    drawerBox.classList.contains('global--cart-drawer__drawer--active');

  drawer.renderContents(state);

  if (!wasOpen) {
    drawer.closeCart();
  }
}

  } catch (err) {
    console.log(err);
  }
});
// end-waqar--changes
})();



// Footer
class FooterMobileMenu extends HTMLElement {
  constructor() {
    super();
    this.footerAccordions = document.querySelectorAll(
      ".component--footer--mobile-menu__item"
    );
    this.footerAccordionButtons = document.querySelectorAll(
      ".component--footer--mobile-menu__titles"
    );
    this.bindEvents();
  }
  bindEvents() {
    this.footerAccordionButtons.forEach((accordion) =>
      accordion.addEventListener("click", this.toggleFooterAccordion.bind(this))
    );
  }
  toggleFooterAccordion(event) {
    const element = event.currentTarget;
    console.log(element);
    for (let i = 0; i < this.footerAccordions.length; i++) {
      if (element == this.footerAccordionButtons[i]) {
        this.footerAccordions[i].classList.toggle(
          "component--footer--mobile-menu__item--active"
        );
      } else {
        this.footerAccordions[i].classList.remove(
          "component--footer--mobile-menu__item--active"
        );
      }
    }
  }
}
customElements.define("footer-mobile-menu", FooterMobileMenu);
class GlobalNewsletter extends HTMLElement {
  constructor() {
    super();
    this.defaults = {
      newsletter: "[data-global-newsletter-form]",
      newsletterInput: ".global--newsletter__input",
      newsletterInputField: ".global--newsletter__field",
      newsletterInputFieldWrapper: ".global--newsletter__field-wrapper",
      newsletterMessages: ".global--newsletter__messages",
      successMessage: ".global--newsletter__success-message",
      errorMessage: ".global--newsletter__error-message",
    };
    this.newsletter = document.querySelector(this.defaults.newsletter);
    this.newsletterInput = document.querySelector(
      this.defaults.newsletterInput
    );
    this.newsletterInputFieldWrapper = document.querySelector(
      this.defaults.newsletterInputFieldWrapper
    );
    this.newsletterInputField = document.querySelector(
      this.defaults.newsletterInputField
    );
    this.newsletterMessages = document.querySelector(
      this.defaults.newsletterMessages
    );
    this.newsletterSuccessMessage = document.querySelector(
      this.defaults.successMessage
    );
    this.newsletterErrorMessage = document.querySelector(
      this.defaults.errorMessage
    );
    this.bindEvents();
  }
  bindEvents() {
    this.newsletter.addEventListener("submit", this.submitForm.bind(this));
  }
  successMessages() {
    this.newsletterSuccessMessage.style.display = "block";
    this.newsletterErrorMessage.style.display = "none";
    this.newsletterInputFieldWrapper.style.display = "none";
    setTimeout(() => {
      this.resetForm();
    }, 5000);
  }
  errorMessages(ele, error) {
    const html = `<svg width="12" height="12" viewBox="0 0 12 12" fill="#e2665c" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0C2.6934 0 0 2.6934 0 6C0 9.3066 2.6934 12 6 12C9.3066 12 12 9.3066 12 6C12 2.6934 9.3066 0 6 0ZM6 1.2C8.65807 1.2 10.8 3.34193 10.8 6C10.8 8.65807 8.65807 10.8 6 10.8C3.34193 10.8 1.2 8.65807 1.2 6C1.2 3.34193 3.34193 1.2 6 1.2ZM5.4 3V4.2H6.6V3H5.4ZM5.4 5.4V9H6.6V5.4H5.4Z" />
            </svg>${error}`;
    ele.innerHTML = html;
    ele.style.display = "flex";
    this.newsletterInput.style.border = "1px solid #e2665c";
  }
  resetForm() {
    this.newsletterSuccessMessage.style.display = "none";
    this.newsletterErrorMessage.style.display = "none";
    this.newsletterInput.style.border = "1px solid #EBEBEC";
    this.newsletterErrorMessage.innerHTML = "";
    this.newsletterInputFieldWrapper.style.display = "block";
    this.newsletterInput.value = "";
  }
  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  subscribe(id, email) {
    const data = {
      g: id,
      email: email,
      $fields: "$source, email",
      $source: "Website",
    };
    const urlData = new URLSearchParams(data);
    const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
    fetch(url, {
      method: "POST",
      async: true,
      crossDomain: true,
      body: urlData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          if (res.data.is_subscribed) {
            this.errorMessages(
              this.newsletterErrorMessage,
              "This email address has already subscribed."
            );
          } else {
            this.successMessages();
          }
        } else {
          this.errorMessages(
            this.newsletterErrorMessage,
            "Invalid Email Address."
          );
        }
      })
      .catch((err) => {
        this.errorMessages(
          this.newsletterErrorMessage,
          "Something went wrong!"
        );
      });
  }
  submitForm(e) {
    e.preventDefault();
    const email = this.newsletter.elements["email"].value;
    const listId = this.newsletter.elements["g"].value;
    if (email !== "") {
      if (this.validateEmail(email)) {
        this.subscribe(listId, email);
      } else {
        this.errorMessages(
          this.newsletterErrorMessage,
          "Invalid Email Address."
        );
      }
    } else {
      this.errorMessages(
        this.newsletterErrorMessage,
        "Email Address Required."
      );
    }
    return false;
  }
}
customElements.define("global-newsletter", GlobalNewsletter);
if (document.querySelector(".component--home--about--video")) {
  const videoWrapper = document.querySelector(".component--home--about--video");
  const button = document.querySelector(".component--home--about--video__play");
  const buttonWrapper = document.querySelector(
    ".component--home--about--video__play-btn"
  );
  buttonWrapper.addEventListener("click", (e) => {
    videoWrapper.querySelector("video").currentTime = 0;
    videoWrapper.querySelector("video").play();
    buttonWrapper.style.display = "none";
    videoWrapper.querySelector("video").muted = false;
  });
  videoWrapper.querySelector("video").addEventListener("click", (e) => {
    buttonWrapper.style.display = "block";
    videoWrapper.querySelector("video").muted = true;
  });
}
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".component--product--ugc--slider")) {
    new Splide(".component--product--ugc--slider", {
      type: "loop",
      perPage: 4,
      perMove: 1,
      pagination: false,
      arrows: false,
      gap: "24px",
      breakpoints: {
        600: {
          perPage: 1,
          gap: "16px",
          padding: "100px",
          pagination: true,
          arrows: true,
        },
      },
    }).mount();
  

  

      
  const videoWrappers = document.querySelectorAll(".page--product--media__video-wrapper");
  
    if (videoWrappers.length > 0) {
      videoWrappers.forEach((video, index) => {
      video.addEventListener("click", async (e) => {
        for (let i = 0; i < videoWrappers.length; i++) {
          const otherVideo = videoWrappers[i].querySelector("video");
          const otherPlayBtn = videoWrappers[i].querySelector(".page--product--media__play-btn");
  
          if (index !== i) {
            if (!otherVideo.paused) {
              otherVideo.pause();
            }
            otherVideo.currentTime = 0;
            otherVideo.muted = true;
            otherPlayBtn.style.display = "block";
          }
        }
  
        const currentVideo = video.querySelector("video");
        const currentPlayBtn = video.querySelector(".page--product--media__play-btn");
  
        if (!currentVideo.muted) {
          currentPlayBtn.style.display = "block";
          currentVideo.pause();
          currentVideo.currentTime = 0;
          currentVideo.muted = true;
            } else {
          currentPlayBtn.style.display = "none";
          currentVideo.currentTime = 0;
          try {
            await currentVideo.play();
            currentVideo.muted = false;
          } catch (error) {
            console.error("Failed to play video:", error);
          }
            }
          });
        });
    }
  
  }
});
document.addEventListener("DOMContentLoaded", function () {
  new Splide(".component--home--reviews--slider", {
    perPage: 3,
    perMove: 1,
    type: "loop",
    pagination: false,
    arrows: false,
    gap: "20px",
    autoWidth: true,
    autoHeight: true,
    focus: "center",
    lazyLoad: "nearby",
    autoScroll: {
      speed: 0.25,
      pauseOnHover: true,
      pauseOnFocus: true,
    },
    breakpoints: {
      768: {
        perPage: 1,
        gap: "0.625rem",
      },
    },
  }).mount(window.splide.Extensions);
  const videoWrappers = document.querySelectorAll(
    ".component--home--review--video"
  );
  if (videoWrappers.length > 0) {
    videoWrappers.forEach((video, index) => {
      video.addEventListener("click", (e) => {
        videoWrappers.forEach((video, i) => {
          if (index != i) {
            video.querySelector("video").muted = true;
            video.querySelector(
              ".component--home--review--video__play-btn"
            ).style.display = "block";
            video.querySelector("video").pause();
            video.querySelector("video").currentTime = 0;
          } else {
            if (video.querySelector("video").muted != true) {
              video.querySelector(
                ".component--home--review--video__play-btn"
              ).style.display = "block";
              video.querySelector("video").pause();
              video.querySelector("video").currentTime = 0;
              video.querySelector("video").muted = true;
            } else {
              video.querySelector("video").currentTime = 0;
              video.querySelector("video").play();
              video.querySelector(
                ".component--home--review--video__play-btn"
              ).style.display = "none";
              video.querySelector("video").muted = false;
            }
          }
        });
      });
    });
  }
  new Splide(".component--home--reviews--slider--mobile", {
    perPage: 3,
    perMove: 1,
    type: "loop",
    pagination: false,
    arrows: false,
    gap: "16px",
    autoWidth: true,
    autoHeight: true,
    focus: "center",
    lazyLoad: "nearby",
    autoScroll: {
      speed: 0.25,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    breakpoints: {
      768: {
        perPage: 1,
        gap: "12px",
      },
    },
  }).mount(window.splide.Extensions);
});
document.addEventListener('DOMContentLoaded', function () {
  const splide = new Splide('.page--home--logos--slider_slider', {
    type: 'loop',
    perPage: 2,
    perMove: 1,
    drag: false,
    focus: 'center',
    lazyLoad: "nearby",
    pagination: false,
    autoWidth: true,
    arrows: false,
    autoScroll: {
      speed: 0.3,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    mediaQuery:'min',
    breakpoints: {
      768: {
        perPage: 3,
      },
      992: {
        perPage: 5,
      },
    },
  });

  splide.mount(window.splide.Extensions);
});
document.addEventListener('DOMContentLoaded', function () {
  const splide = new Splide('.page--home--partners_slider', {
    type: 'loop',
    perPage: 2,
    perMove: 1,
    drag: false,
    focus: 'center',
    lazyLoad: "nearby",
    pagination: false,
    autoWidth: true,
    arrows: false,
    autoScroll: {
      speed: 0.3,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    mediaQuery:'min',
    breakpoints: {
      768: {
        perPage: 2,
      },
    },
  });

  splide.mount(window.splide.Extensions);
});
document.addEventListener('DOMContentLoaded', function () {
  const splideElement = document.querySelector('.page--home--solution--cards_slider');
  const splide = new Splide(splideElement, {
    perPage: 2,
    perMove: 1,
    drag: true,
    pagination: false,
    arrows: true,
    gap: '8px',
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 3,
        gap: '16px',
      },
      992: {
        perPage: 4,
      },
    },
  });

  splide.mount();
  const scrollbarContainer = document.createElement('div');
  scrollbarContainer.className = 'custom-scrollbar';
  const scrollbar = document.createElement('div');
  scrollbar.className = 'custom-scrollbar__thumb';
  scrollbarContainer.appendChild(scrollbar);
  splideElement.appendChild(scrollbarContainer);

  const updateScrollbar = () => {
    const totalSlides = splide.Components.Slides.getLength();
    const visibleSlides = splide.options.perPage;
    const trackWidth = scrollbarContainer.offsetWidth;

    if (trackWidth === 0) {
      requestAnimationFrame(updateScrollbar);
      return;
    }

    const thumbWidth = Math.max((trackWidth * visibleSlides) / totalSlides, 20); // Minimum width for usability
    scrollbar.style.width = `${thumbWidth}px`;

    const maxScrollLeft = trackWidth - thumbWidth;
    const scrollPosition = (splide.index / (totalSlides - visibleSlides)) * maxScrollLeft;
    scrollbar.style.transform = `translateX(${scrollPosition}px)`;
  };

  splide.on('move', updateScrollbar);
  splide.on('mounted', updateScrollbar);
  splide.on('updated', updateScrollbar);
  let isDragging = false;
  let startX = 0;
  let startScrollPosition = 0;

  const startDrag = (e) => {
    isDragging = true;
    startX = e.touches ? e.touches[0].clientX : e.clientX;
    const transform = window.getComputedStyle(scrollbar).transform;
    startScrollPosition = transform !== 'none' ? parseFloat(transform.split(',')[4]) : 0;
    document.body.style.userSelect = 'none';
  };

  const drag = (e) => {
    if (!isDragging) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const trackWidth = scrollbarContainer.offsetWidth;
    const thumbWidth = scrollbar.offsetWidth;
    const maxScrollLeft = trackWidth - thumbWidth;
    const deltaX = clientX - startX;
    let newScrollPosition = startScrollPosition + deltaX;
    newScrollPosition = Math.max(0, Math.min(maxScrollLeft, newScrollPosition));
    scrollbar.style.transform = `translateX(${newScrollPosition}px)`;
    const totalSlides = splide.Components.Slides.getLength();
    const visibleSlides = splide.options.perPage;
    const sliderIndex = Math.round((newScrollPosition / maxScrollLeft) * (totalSlides - visibleSlides));
    splide.go(sliderIndex);
  };

  const endDrag = () => {
    if (isDragging) {
      isDragging = false;
      document.body.style.userSelect = '';
    }
  };
  scrollbar.addEventListener('mousedown', startDrag);
  document.addEventListener('mousemove', drag);
  document.addEventListener('mouseup', endDrag);
  scrollbar.addEventListener('touchstart', startDrag, { passive: true });
  document.addEventListener('touchmove', drag, { passive: true });
  document.addEventListener('touchend', endDrag);
  setTimeout(updateScrollbar, 100);
});
document.addEventListener('DOMContentLoaded', function () {
  const splideElement = document.querySelector('.page--home--partners--cards_slider');
  const splide = new Splide(splideElement, {
    perPage: 2,
    perMove: 1,
    drag: true,
    pagination: false,
    arrows: true,
    gap: '8px',
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 3,
        gap: '16px',
      },
      992: {
        perPage: 4,
      },
    },
  });

  splide.mount();
  const scrollbarContainer = document.createElement('div');
  scrollbarContainer.className = 'custom-scrollbar';
  const scrollbar = document.createElement('div');
  scrollbar.className = 'custom-scrollbar__thumb';
  scrollbarContainer.appendChild(scrollbar);
  splideElement.appendChild(scrollbarContainer);

  const updateScrollbar = () => {
    const totalSlides = splide.Components.Slides.getLength();
    const visibleSlides = splide.options.perPage;
    const trackWidth = scrollbarContainer.offsetWidth;

    if (trackWidth === 0) {
      requestAnimationFrame(updateScrollbar);
      return;
    }

    const thumbWidth = Math.max((trackWidth * visibleSlides) / totalSlides, 20); // Minimum width for usability
    scrollbar.style.width = `${thumbWidth}px`;

    const maxScrollLeft = trackWidth - thumbWidth;
    const scrollPosition = (splide.index / (totalSlides - visibleSlides)) * maxScrollLeft;
    scrollbar.style.transform = `translateX(${scrollPosition}px)`;
  };

  splide.on('move', updateScrollbar);
  splide.on('mounted', updateScrollbar);
  splide.on('updated', updateScrollbar);
  let isDragging = false;
  let startX = 0;
  let startScrollPosition = 0;

  const startDrag = (e) => {
    isDragging = true;
    startX = e.touches ? e.touches[0].clientX : e.clientX;
    const transform = window.getComputedStyle(scrollbar).transform;
    startScrollPosition = transform !== 'none' ? parseFloat(transform.split(',')[4]) : 0;
    document.body.style.userSelect = 'none';
  };

  const drag = (e) => {
    if (!isDragging) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const trackWidth = scrollbarContainer.offsetWidth;
    const thumbWidth = scrollbar.offsetWidth;
    const maxScrollLeft = trackWidth - thumbWidth;
    const deltaX = clientX - startX;
    let newScrollPosition = startScrollPosition + deltaX;
    newScrollPosition = Math.max(0, Math.min(maxScrollLeft, newScrollPosition));
    scrollbar.style.transform = `translateX(${newScrollPosition}px)`;
    const totalSlides = splide.Components.Slides.getLength();
    const visibleSlides = splide.options.perPage;
    const sliderIndex = Math.round((newScrollPosition / maxScrollLeft) * (totalSlides - visibleSlides));
    splide.go(sliderIndex);
  };

  const endDrag = () => {
    if (isDragging) {
      isDragging = false;
      document.body.style.userSelect = '';
    }
  };
  scrollbar.addEventListener('mousedown', startDrag);
  document.addEventListener('mousemove', drag);
  document.addEventListener('mouseup', endDrag);
  scrollbar.addEventListener('touchstart', startDrag, { passive: true });
  document.addEventListener('touchmove', drag, { passive: true });
  document.addEventListener('touchend', endDrag);
  setTimeout(updateScrollbar, 100);
});


document.addEventListener("DOMContentLoaded", function () {
  const babies_slider = document.querySelector('.page--home--happy--moms--babies_slider');
if (babies_slider) {
  new Splide(".page--home--happy--moms--babies_slider", {
    perPage: 2,
    perMove: 1,
    drag: true,
    pagination: false,
    arrows: false,
    gap: '8px',
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 3,
        gap: '16px',
      },
      992: {
        destroy: true,
      },
    },
  }).mount();
}
const as_seen_in_slider = document.querySelector('.as-seen-in-splide');
if (as_seen_in_slider) {
          new Splide(".as-seen-in-splide", {
        perPage: 3,
        perMove: 1,
        pagination: false,
        arrows: false,
        gap: "100px",
        breakpoints: {
          600: {
            perPage: 1,
            gap: "16px",
            pagination: true,
            arrows: true
          },
        },
      }).mount();
}
const our_mission_slider = document.querySelector('.our-mission-splide');
if (our_mission_slider) {
       new Splide(".our-mission-splide", {
        type   : 'loop',
        perPage: 1,
        perMove: 1,
          focus    : 'center',
        pagination: true,
        arrows: true
      }).mount();  
}
  });

  
     document.addEventListener("DOMContentLoaded", function() {
  
          document.getElementById('addon-product').addEventListener('change', function() {
  /*
              var xhrClear = new XMLHttpRequest();
              xhrClear.open("POST", '/cart/clear.js', true);
              xhrClear.setRequestHeader('Content-Type', 'application/json');
              xhrClear.onreadystatechange = function () {
                  if (xhrClear.readyState === 4 && xhrClear.status === 200) {
                      preview_product();
                  } else if (xhrClear.readyState === 4) {
                      console.error('Clear cart error:', xhrClear.statusText);
                  }
              };
              xhrClear.send();
              */
            if (this.checked == true) {}
            else {}
          });
  
          function preview_product() {
              console.log("Clicked");
            /*
              var productId = document.getElementById('addon-product').value; // Get the product ID
              var quantity = document.getElementById('addon-product').checked ? 1 : 0; // Determine if adding or removing
  
              console.log('Quantity:', quantity); // Debugging: Log the quantity
  
              // Data to send in the AJAX request
              var data = JSON.stringify({
                  'items': [{
                      'id': productId,
                      'quantity': quantity
                  }]
              });
  
              console.log('Sending data:', data); // Debugging: Log the data being sent
  
              var xhrAdd = new XMLHttpRequest();
              xhrAdd.open("POST", '/cart/add.js', true);
              xhrAdd.setRequestHeader('Content-Type', 'application/json');
              xhrAdd.onreadystatechange = function () {
                  if (xhrAdd.readyState === 4 && xhrAdd.status === 200) {
                      console.log('Cart updated:', JSON.parse(xhrAdd.responseText));
                      // Optionally update cart display here
                  } else if (xhrAdd.readyState === 4) {
                      console.error('Cart update error:', xhrAdd.statusText);
                  }
              };
              xhrAdd.send(data);
              */
          }
});
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".page--reviews--media__slider")) {
    new Splide(".page--reviews--media__slider", {
      type: "loop",
      perPage: 4,
      perMove: 1,
      pagination: false,
      arrows: true,
      gap: "24px",
      breakpoints: {
        600: {
          perPage: 1,
          gap: "16px",
          padding: "100px",
          pagination: true,
          arrows: false,
        },
      },
    }).mount();
    const videoWrappers = document.querySelectorAll(
      ".page--product--media__video-wrapper"
    );
    if (videoWrappers.length > 0) {
      videoWrappers.forEach((video, index) => {
        video.addEventListener("click", (e) => {
          videoWrappers.forEach((video, i) => {
            if (index != i) {
              video.querySelector("video").muted = true;
              video.querySelector(
                ".page--product--media__play-btn"
              ).style.display = "block";
              video.querySelector("video").pause();
              video.querySelector("video").currentTime = 0;
            } else {
              if (video.querySelector("video").muted != true) {
                video.querySelector(
                  ".page--product--media__play-btn"
                ).style.display = "block";
                video.querySelector("video").pause();
                video.querySelector("video").currentTime = 0;
                video.querySelector("video").muted = true;
              } else {
                video.querySelector("video").currentTime = 0;
                video.querySelector("video").play();
                video.querySelector(
                  ".page--product--media__play-btn"
                ).style.display = "none";
                video.querySelector("video").muted = false;
              }
            }
          });
        });
      });
    }
  }
});

document.querySelectorAll(".nutritional-fact-button").forEach(function(image) {
  image.addEventListener('click', function() {
    let src = image.getAttribute('data-image');
    if (src.includes('?')) {
      src = src.split('?')[0];
    }
    const modal = document.querySelector(".custom-model-main");
    modal.classList.add('model-open');
    document.body.classList.add('image-poped');
    const modalImage = modal.querySelector('img');
    if (modalImage) {
      modalImage.setAttribute('src', src);
    }
  });
});
document.querySelectorAll(".desktop-media .component--product--media__image-wrapper img").forEach(function(image) {
    image.addEventListener('click', function() {
        const parentDiv = image.closest('.video_wrapper');
        if (parentDiv) {
            const videoTag = parentDiv.querySelector('.video_src');
            const videoSource = videoTag.querySelector('source');
            const videoLink = videoSource.getAttribute('src');
            const modal = document.querySelector(".custom-model-main.video_popup_wrapper");
            const modalVideo = modal.querySelector('video source');

            if (modalVideo) {
                modalVideo.setAttribute('src', videoLink);
                const videoElement = modal.querySelector('video');
                videoElement.load(); 
            }

            modal.classList.add('model-open');
            document.body.classList.add('image-poped');

        } else {
            let src = image.getAttribute('src');
            if (src.includes('?')) {
                src = src.split('?')[0];
            }
            const modal = document.querySelector(".custom-model-main.image_popup_wrapper");
            modal.classList.add('model-open');
            document.body.classList.add('image-poped');
            const modalImage = modal.querySelector('img');
            if (modalImage) {
                modalImage.setAttribute('src', src);
            }
        }
    });
});
document.querySelectorAll(".close-btn.image-close-btn, .bg-overlay.image-overlay").forEach(function(element) {
  element.addEventListener('click', function() {
    const modal = document.querySelector(".custom-model-main.image_popup_wrapper");
    modal.classList.remove('model-open');
    document.body.classList.remove('image-poped');
  });
});document.querySelectorAll(".close-btn.video-close-btn, .bg-overlay.video-overlay").forEach(function(element) {
  element.addEventListener('click', function() {
    const modal = document.querySelector(".custom-model-main.video_popup_wrapper");
    const vidoeTag = document.querySelector(".custom-model-main.video_popup_wrapper video source");
    vidoeTag.setAttribute('src', '');
    modal.classList.remove('model-open');
    document.body.classList.remove('image-poped');
  });
});
document.querySelectorAll(".close-btn, .bg-overlay").forEach(function(element) {
  element.addEventListener('click', function() {
    const modal = document.querySelector(".custom-model-main");
    modal.classList.remove('model-open');
    document.body.classList.remove('image-poped');
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const videoItems = document.querySelectorAll('.video-item');
    const popup = document.getElementById('videoPopup');
    const popupVideo = document.getElementById('popupVideo');
    const closeBtn = document.querySelector('.close');

    videoItems.forEach(item => {
        item.addEventListener('click', function () {
            const videoSrc = this.getAttribute('data-video-src');
            popupVideo.src = videoSrc;
            popup.style.display = 'block';
          document.querySelector('body').classList.add('lock-scroll');
        });
    });

    closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';
        popupVideo.src = '';
        document.querySelector('body').classList.remove('lock-scroll');
    });

    window.addEventListener('click', function (event) {
        if (event.target === popup) {
            popup.style.display = 'none';
            popupVideo.src = '';
        document.querySelector('body').classList.remove('lock-scroll');
        }
    });
});



var acc = document.getElementsByClassName("accordion");
  //var images = document.getElementsByClassName("image");

  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      // Close all panels and hide all images
      for (var j = 0; j < acc.length; j++) {
        acc[j].classList.remove("active");
        var panel = acc[j].nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        }
        //images[j].style.display = "none";
      }

      // Open the clicked panel and show the respective image
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      var index = this.getAttribute("data-index");
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
      //document.getElementById("image" + index).style.display = "block";
    });
  }


        document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('.accordion');
    const images = document.querySelectorAll('.image');
    const pills = document.querySelectorAll('.accordionBox_paginationPill');
    const mobileAccordionNos = document.querySelectorAll('.eachAccordionNo');
    const mobileText = document.querySelector('.selectedOptionEachAccordion');

    const mobileContent = [
        {
            title: 'Separation and Labeling',
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
            title: 'Bacteria Testing',
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
            title: 'Dedicated Chambers',
            text: 'We have dedicated freeze-drying chambers for each mom, ensuring that her milk is processed individually. This exclusive handling guarantees that her milk is freeze-dried without mixing with any other mom\'s milk.'
        },
        {
            title: 'Sterile Processing',
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
            title: 'Freeze-Drying',
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        }
    ];

    accordions.forEach(accordion => {
        accordion.addEventListener('click', function() {
            const index = this.getAttribute('data-index');
            setActiveAccordion(index);
        });
    });

    mobileAccordionNos.forEach(no => {
        no.addEventListener('click', function() {
            const index = this.getAttribute('data-index');
            setActiveAccordion(index);
            updateMobileText(index);
        });
    });

    function setActiveAccordion(index) {
        // Update active image
      /*
        images.forEach(image => {
            image.classList.remove('active');
        });
        document.getElementById(`image${index}`).classList.add('active');
      */

        // Update active pill
      /*
        pills.forEach(pill => {
            pill.classList.remove('active');
        });
        document.querySelector(`.accordionBox_paginationPill[data-index="${index}"]`).classList.add('active');
      */

        // Update active mobile number
        mobileAccordionNos.forEach(no => {
            no.classList.remove('active');
        });
        document.querySelector(`.eachAccordionNo[data-index="${index}"]`).classList.add('active');
    }

    function updateMobileText(index) {
        mobileText.querySelector('h4').textContent = window.journeyContent[index - 1].title;
        mobileText.querySelector('p').textContent = window.journeyContent[index - 1].text;
    }

    const highlightedLine = document.querySelector('.highlightedLine');
    const sections = document.querySelectorAll('.eachSectionNoBox');
    const sectionNumbers = document.querySelectorAll('.eachSectionNoBoxNo');
    const journeySection = document.querySelector('.journeySection');
    sections.forEach((section, index) => {
        section.classList.remove('active');
        sectionNumbers[index].classList.remove('active');
    });

  window.addEventListener('scroll', () => {
    if (!document.querySelector('.journeySection')) return;
    if (document.querySelector('.journeySection').offsetTop <= window.scrollY + window.innerHeight / 2) {
      const heightPixel = (window.scrollY + window.innerHeight / 2) - document.querySelector('.journeySection').offsetTop;
       highlightedLine.style.height = `${heightPixel}px`;
      document.querySelector('.pin').classList.add('active');
    }
    else {
      document.querySelector('.pin').classList.remove('active');
    }
    const scrollY = window.scrollY;
    /*
    const documentHeight = journeySection.scrollHeight - journeySection.clientHeight;
    const heightPercentage = (scrollY / documentHeight) * 100;
    highlightedLine.style.height = `${heightPercentage}%`;
    */

    console.log(scrollY);

    const journeySectionRect = journeySection.getBoundingClientRect();
    const highlightedLineRect = highlightedLine.getBoundingClientRect();
    const highlightedLineTop = highlightedLineRect.top - journeySectionRect.top + scrollY;
    const highlightedLineBottom = highlightedLineRect.bottom - journeySectionRect.top + scrollY;

    sections.forEach((section, index) => {
        const sectionRect = section.getBoundingClientRect();
        const sectionTop = sectionRect.top - journeySectionRect.top + scrollY;
        const sectionBottom = sectionTop + section.offsetHeight;

        if (highlightedLineBottom >= sectionTop && highlightedLineTop <= sectionBottom) {
            section.classList.add('active');
            sectionNumbers[index].classList.add('active');
        } else {
            section.classList.remove('active');
            sectionNumbers[index].classList.remove('active');
        }
    });
});

});

// window.updateCartProgressBar = function () {
//   fetch('/cart.js')
//     .then(r => r.json())
//     .then(cart => {
      
//       const bar = document.querySelector('.pre-cart-progress');
//       const fill = document.querySelector('.pre-cart-progress-fill');
//       const text = document.querySelector('.pre-cart-progress-text');

//       if (!bar || !fill || !text) return;

//       // If cart empty → hide bar
//       if (cart.item_count === 0) {
//         bar.style.display = 'none';
//         return;
//       } else {
//         bar.style.display = 'block';
//       }

//       const goal = 10000; // $100
//       const total = cart.total_price;
//       const percent = Math.min((total / goal) * 100, 100);

//       fill.style.width = percent + '%';

//       if (total >= goal) {
//         text.innerText = 'You unlocked FREE gifts!';
//       } else {
//         const remain = ((goal - total) / 100).toFixed(2);
//         text.innerText = `Spend $${remain} more to get FREE gifts`;
//       }
//     });
// };


// document.addEventListener("DOMContentLoaded", () => {
//   setTimeout(() => {
//     if (window.updateCartProgressBar) updateCartProgressBar();
//   }, 50);
// });


// nutritions--popup--js
document.addEventListener('click', function (e) {

  const nutritionBtn = e.target.closest('.nutrition-facts-button a');

  if (nutritionBtn) {
    e.preventDefault();

    const nutritionPopup = document.querySelector('.nutrition-popup');

    nutritionPopup.classList.add('active');
    document.body.classList.add('nutrition-popup-open');

    return;
  }

  const closeBtn = e.target.closest('.nutrition-popup-close');
  const overlay = e.target.classList.contains('nutrition-popup-overlay');

  if (closeBtn || overlay) {
    const nutritionPopup = document.querySelector('.nutrition-popup');

    nutritionPopup.classList.remove('active');
    document.body.classList.remove('nutrition-popup-open');
  }

});